import '@mantine/core/styles.layer.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import "@clinicaltoolkits/universal-react-components/dist/styles/global.css"
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

console.log('Launching site!');

// Get the root element from the HTML
const container = document.getElementById('root');
if (!container) throw new Error("Root container not found");

// Create a React root and render the component
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
